<template>
    <div class="vm-order-withdraw">
        <div class="black-3" v-if="withdraw.status == withdraw_status.success">交易订单：{{withdraw.order_id}}</div>
        <div class="flex-box flex-align-items-baseline mt8 black-8">
            <div class="item-tit">{{$t('c.OrderWithdraw.text1')}}</div>
            <div>￥{{withdraw.pay_amount}}</div>
        </div>
        <div class="flex-box flex-align-items-baseline mt8 black-8">
            <div class="item-tit">{{$t('c.OrderWithdraw.text2')}}</div>
            <span v-text="$time_show(withdraw.apply_time, 'YYYY-MM-DD HH:mm:ss', true)"></span>
        </div>
        <div class="flex-box flex-align-items-baseline mt8 black-8">
            <div class="item-tit">{{$t('c.OrderWithdraw.text3')}}</div>
            <div>{{status_text}}</div>
        </div>
        <div class="flex-box flex-align-items-baseline mt8 black-8" v-if="withdraw.status == withdraw_status.error">
            <div class="item-tit">{{$t('c.OrderWithdraw.text4')}}</div>
            <div>
                {{withdraw.deal_error}}
                <router-link class="underline purple ml16" to="/setting/payment">{{$t('c.OrderWithdraw.text5')}}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'withdraw',
    props: {
        withdraw:{
            type:Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {

        }
    },
    computed:{
        ...mapState('app', [
            'withdraw_status'
        ]),
        status_text(){
            if(this.withdraw.status == this.withdraw_status.waiting){
                return '等待审核中…'
            }
            if(this.withdraw.status == this.withdraw_status.success){
                return '已完成'
            }
            if(this.withdraw.status == this.withdraw_status.error){
                return '提现失败'
            }
            if(this.withdraw.status == this.withdraw_status.bank_error){
                return '银行系统返回失败，您的银行卡可能有收款限制'
            }
            return ''
        },

    },

    mounted() {

    },
    methods: {

    }
};
</script>

<style lang="stylus" scoped>
.vm-order-withdraw{
    .item-tit{
        min-width px2rem(80)
    }
}
</style>
